import { render, staticRenderFns } from "./DiseasesClassificationAutosuggest.vue?vue&type=template&id=721d9dcc&"
import script from "./DiseasesClassificationAutosuggest.vue?vue&type=script&lang=js&"
export * from "./DiseasesClassificationAutosuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports